import React from 'react';
import { SpacingBox, RowFlexBox } from '../../Components';
import { RemoveOrderButton } from './RemoveOrderButton';
import { CopyOrderButton } from './CopyOrderButton.1';
import { OrderPDFButton } from './OrderPDFButton';
import { ColourBookButton } from '../ColourBookButton';
import AppContext from '../../AppContext';

export const Actions = (props) => (
  <RowFlexBox alignItems="center">
    <AppContext.Consumer>
      {(context) => (
        <>
        <RemoveOrderButton context={context} order={props.order} actions={props.actions} id={props.id} onAction={props.onAction} />
        <SpacingBox marginLeft="sm">
          <CopyOrderButton id={props.id} onAction={props.onAction} />
        </SpacingBox>
          <SpacingBox marginLeft="sm">
            <OrderPDFButton
              status={props.status}
              id={props.id}
              context={context}
            />
          </SpacingBox>
          <SpacingBox marginLeft="sm">
            <ColourBookButton
              id={props.id}
              status={props.status}
              currency={props.currency}
              context={context}
            />
          </SpacingBox>
        </>
      )}
    </AppContext.Consumer>
  </RowFlexBox>
);
